 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01_FRONTCOVERIMAGE from '@/components/001_frontcoverImage'
 import A02_DEDICATION from '@/components/002_dedication'
 import A03_TITLEPAGEPAGE from '@/components/003_titlepagePage'
 import A04_COPYRIGHTPAGE from '@/components/004_copyrightPage'
 import A05_TOC from '@/components/005_toc'
 import A06_ACKNOWLEDGEMENTS from '@/components/006_acknowledgements'
 import A07_INTRODUCTION from '@/components/007_introduction'
 import A08_CH01 from '@/components/008_ch01'
 import A09_CH0101 from '@/components/009_ch0101'
 import A10_CH0102 from '@/components/010_ch0102'
 import A11_CH02 from '@/components/011_ch02'
 import A12_CH03 from '@/components/012_ch03'
 import A13_CH0301 from '@/components/013_ch0301'
 import A14_CH0302 from '@/components/014_ch0302'
 import A15_CH0303 from '@/components/015_ch0303'
 import A16_CH0304 from '@/components/016_ch0304'
 import A17_CH0305 from '@/components/017_ch0305'
 import A18_CH0306 from '@/components/018_ch0306'
 import A19_CH0307 from '@/components/019_ch0307'
 import A20_CH0308 from '@/components/020_ch0308'
 import A21_CH0309 from '@/components/021_ch0309'
 import A22_CH0310 from '@/components/022_ch0310'
 import A23_CH0311 from '@/components/023_ch0311'
 import A24_CH0312 from '@/components/024_ch0312'
 import A25_CH0313 from '@/components/025_ch0313'
 import A26_CH04 from '@/components/026_ch04'
 import A27_CH0401 from '@/components/027_ch0401'
 import A28_CH0402 from '@/components/028_ch0402'
 import A29_CH0403 from '@/components/029_ch0403'
 import A30_CH0404 from '@/components/030_ch0404'
 import A31_CH0405 from '@/components/031_ch0405'
 import A32_CH0406 from '@/components/032_ch0406'
 import A33_CH0407 from '@/components/033_ch0407'
 import A34_CH0408 from '@/components/034_ch0408'
 import A35_CH0409 from '@/components/035_ch0409'
 import A36_CH0410 from '@/components/036_ch0410'
 import A37_CH0411 from '@/components/037_ch0411'
 import A38_CH0412 from '@/components/038_ch0412'
 import A39_CH0413 from '@/components/039_ch0413'
 import A40_CH0414 from '@/components/040_ch0414'
 import A41_CH0415 from '@/components/041_ch0415'
 import A42_CH0416 from '@/components/042_ch0416'
 import A43_CH0417 from '@/components/043_ch0417'
 import A44_CH0418 from '@/components/044_ch0418'
 import A45_CH0419 from '@/components/045_ch0419'
 import A46_CH0420 from '@/components/046_ch0420'
 import A47_CH0421 from '@/components/047_ch0421'
 import A48_CH0422 from '@/components/048_ch0422'
 import A49_CH0423 from '@/components/049_ch0423'
 import A50_CH0424 from '@/components/050_ch0424'
 import A51_CH0425 from '@/components/051_ch0425'
 import A52_CH0426 from '@/components/052_ch0426'
 import A53_CH0427 from '@/components/053_ch0427'
 import A54_CH0428 from '@/components/054_ch0428'
 import A55_CH0429 from '@/components/055_ch0429'
 import A56_CH0430 from '@/components/056_ch0430'
 import A57_CH0431 from '@/components/057_ch0431'
 import A58_CH0432 from '@/components/058_ch0432'
 import A59_CH0433 from '@/components/059_ch0433'
 import A60_CH0434 from '@/components/060_ch0434'
 import A61_CH0435 from '@/components/061_ch0435'
 import A62_CH0436 from '@/components/062_ch0436'
 import A63_CH0437 from '@/components/063_ch0437'
 import A64_CH0438 from '@/components/064_ch0438'
 import A65_CH0439 from '@/components/065_ch0439'
 import A66_CH0440 from '@/components/066_ch0440'
 import A67_CH0441 from '@/components/067_ch0441'
 import A68_CH0442 from '@/components/068_ch0442'
 import A69_CH0443 from '@/components/069_ch0443'
 import A70_CH0444 from '@/components/070_ch0444'
 import A71_CH0445 from '@/components/071_ch0445'
 import A72_CH0446 from '@/components/072_ch0446'
 import A73_CH0447 from '@/components/073_ch0447'
 import A74_CH05 from '@/components/074_ch05'
 import A75_CH0501 from '@/components/075_ch0501'
 import A76_CH0502 from '@/components/076_ch0502'
 import A77_CH0503 from '@/components/077_ch0503'
 import A78_CH0504 from '@/components/078_ch0504'
 import A79_CH0505 from '@/components/079_ch0505'
 import A80_CH0506 from '@/components/080_ch0506'
 import A81_CH0507 from '@/components/081_ch0507'
 import A82_CH0508 from '@/components/082_ch0508'
 import A83_CH0509 from '@/components/083_ch0509'
 import A84_CH0510 from '@/components/084_ch0510'
 import A85_CH0511 from '@/components/085_ch0511'
 import A86_CH0512 from '@/components/086_ch0512'
 import A87_CH0513 from '@/components/087_ch0513'
 import A88_CH0514 from '@/components/088_ch0514'
 import A89_CH0515 from '@/components/089_ch0515'
 import A90_CH0516 from '@/components/090_ch0516'
 import A91_CH0517 from '@/components/091_ch0517'
 import A92_CH0518 from '@/components/092_ch0518'
 import A93_CH0519 from '@/components/093_ch0519'
 import A94_CH0520 from '@/components/094_ch0520'
 import A95_CH0521 from '@/components/095_ch0521'
 import A96_CH0522 from '@/components/096_ch0522'
 import A97_CH0523 from '@/components/097_ch0523'
 import A98_CH0524 from '@/components/098_ch0524'
 import A99_CH0525 from '@/components/099_ch0525'
 import A00_CH0526 from '@/components/100_ch0526'
 import A01_CH0527 from '@/components/101_ch0527'
 import A02_CH0528 from '@/components/102_ch0528'
 import A03_CH0529 from '@/components/103_ch0529'
 import A04_CH0530 from '@/components/104_ch0530'
 import A05_CH0531 from '@/components/105_ch0531'
 import A06_CH0532 from '@/components/106_ch0532'
 import A07_CH06 from '@/components/107_ch06'
 import A08_CH0601 from '@/components/108_ch0601'
 import A09_CH0602 from '@/components/109_ch0602'
 import A10_CH0603 from '@/components/110_ch0603'
 import A11_CH0604 from '@/components/111_ch0604'
 import A12_CH0605 from '@/components/112_ch0605'
 import A13_CH0606 from '@/components/113_ch0606'
 import A14_CH0607 from '@/components/114_ch0607'
 import A15_CH0608 from '@/components/115_ch0608'
 import A16_CH0609 from '@/components/116_ch0609'
 import A17_CH0610 from '@/components/117_ch0610'
 import A18_CH0611 from '@/components/118_ch0611'
 import A19_CH0612 from '@/components/119_ch0612'
 import A20_CH0613 from '@/components/120_ch0613'
 import A21_CH0614 from '@/components/121_ch0614'
 import A22_CH0615 from '@/components/122_ch0615'
 import A23_CH0616 from '@/components/123_ch0616'
 import A24_CH0617 from '@/components/124_ch0617'
 import A25_CH0618 from '@/components/125_ch0618'
 import A26_CH0619 from '@/components/126_ch0619'
 import A27_CH0620 from '@/components/127_ch0620'
 import A28_CH0621 from '@/components/128_ch0621'
 import A29_CH0622 from '@/components/129_ch0622'
 import A30_CH0623 from '@/components/130_ch0623'
 import A31_CH0624 from '@/components/131_ch0624'
 import A32_CH0625 from '@/components/132_ch0625'
 import A33_CH0626 from '@/components/133_ch0626'
 import A34_CH0627 from '@/components/134_ch0627'
 import A35_CH0628 from '@/components/135_ch0628'
 import A36_CH0629 from '@/components/136_ch0629'
 import A37_CH0630 from '@/components/137_ch0630'
 import A38_CH0631 from '@/components/138_ch0631'
 import A39_CH0632 from '@/components/139_ch0632'
 import A40_CH0633 from '@/components/140_ch0633'
 import A41_CH0634 from '@/components/141_ch0634'
 import A42_CH0635 from '@/components/142_ch0635'
 import A43_CH0636 from '@/components/143_ch0636'
 import A44_CH0637 from '@/components/144_ch0637'
 import A45_CH0638 from '@/components/145_ch0638'
 import A46_CH0639 from '@/components/146_ch0639'
 import A47_CH0640 from '@/components/147_ch0640'
 import A48_CH0641 from '@/components/148_ch0641'
 import A49_CH0642 from '@/components/149_ch0642'
 import A50_CH0643 from '@/components/150_ch0643'
 import A51_CH07 from '@/components/151_ch07'
 import A52_CH0701 from '@/components/152_ch0701'
 import A53_CH0702 from '@/components/153_ch0702'
 import A54_CH0703 from '@/components/154_ch0703'
 import A55_CH0704 from '@/components/155_ch0704'
 import A56_CH0705 from '@/components/156_ch0705'
 import A57_CH0706 from '@/components/157_ch0706'
 import A58_CH0707 from '@/components/158_ch0707'
 import A59_CH0708 from '@/components/159_ch0708'
 import A60_CH0709 from '@/components/160_ch0709'
 import A61_CH0710 from '@/components/161_ch0710'
 import A62_CH0711 from '@/components/162_ch0711'
 import A63_CH0712 from '@/components/163_ch0712'
 import A64_CH0713 from '@/components/164_ch0713'
 import A65_CH0714 from '@/components/165_ch0714'
 import A66_CH0715 from '@/components/166_ch0715'
 import A67_CH0716 from '@/components/167_ch0716'
 import A68_CH0717 from '@/components/168_ch0717'
 import A69_CH0718 from '@/components/169_ch0718'
 import A70_CH0719 from '@/components/170_ch0719'
 import A71_CH0720 from '@/components/171_ch0720'
 import A72_CH0721 from '@/components/172_ch0721'
 import A73_CH08 from '@/components/173_ch08'
 import A74_CH0801 from '@/components/174_ch0801'
 import A75_CH0802 from '@/components/175_ch0802'
 import A76_CH0803 from '@/components/176_ch0803'
 import A77_CH0804 from '@/components/177_ch0804'
 import A78_CH0805 from '@/components/178_ch0805'
 import A79_CH0806 from '@/components/179_ch0806'
 import A80_CH0807 from '@/components/180_ch0807'
 import A81_CH0808 from '@/components/181_ch0808'
 import A82_CH0809 from '@/components/182_ch0809'
 import A83_BIBLIOGRAPHY from '@/components/183_bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/005_toc",
 			"name" : "005_toc",
 			"component" : A05_TOC
 		},
 		{
 			"path" : "/006_acknowledgements",
 			"name" : "006_acknowledgements",
 			"component" : A06_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/007_introduction",
 			"name" : "007_introduction",
 			"component" : A07_INTRODUCTION
 		},
 		{
 			"path" : "/008_ch01",
 			"name" : "008_ch01",
 			"component" : A08_CH01
 		},
 		{
 			"path" : "/009_ch0101",
 			"name" : "009_ch0101",
 			"component" : A09_CH0101
 		},
 		{
 			"path" : "/010_ch0102",
 			"name" : "010_ch0102",
 			"component" : A10_CH0102
 		},
 		{
 			"path" : "/011_ch02",
 			"name" : "011_ch02",
 			"component" : A11_CH02
 		},
 		{
 			"path" : "/012_ch03",
 			"name" : "012_ch03",
 			"component" : A12_CH03
 		},
 		{
 			"path" : "/013_ch0301",
 			"name" : "013_ch0301",
 			"component" : A13_CH0301
 		},
 		{
 			"path" : "/014_ch0302",
 			"name" : "014_ch0302",
 			"component" : A14_CH0302
 		},
 		{
 			"path" : "/015_ch0303",
 			"name" : "015_ch0303",
 			"component" : A15_CH0303
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js